<template>
  <div class="Fuell-Table--row">
    <router-link
      :to="`/budgets/detail/${budget.budget.id}/`"
      custom
      v-slot="{ navigate }"
    >
      <div
        class="Fuell-Table--item clickable"
        role="link"
        @click="navigate"
      >{{ budgetName }}</div>
    </router-link>
    <router-link
      :to="`/budgets/detail/${budget.budget.id}/`"
      custom
      v-slot="{ navigate }"
    >
      <div
        class="Fuell-Table--item clickable"
        role="link"
        @click="navigate"
      >
        <div class="flex">
          <user-name-badge
            :userName="userName"
            :userAvatarId="userProfilePictureId"
          ></user-name-badge>
          <div class="user-name-field">
            <span class="ellipsis dark">{{ userName }}</span>
            <span
              v-if="isOwner"
              v-t="{ path: 'budget_user_member_owner' }"
            ></span>
          </div>
        </div>
      </div>
    </router-link>
    <div class="Fuell-Table--item">
      <div
        v-show="!editableFlag"
        class="Fuell-TableInput clickable"
        role="button"
        @click="toggleEditFlag"
      >
        {{
          assigned
            | currency('€', 2, {
              symbolOnLeft: false,
              thousandsSeparator: '.',
              decimalSeparator: ','
            })
        }}
        <div class="Fuell-TableInput--icon-container">
          <img
            class
            alt="icon-edit"
            role="button"
            :src="require('@/assets/img/icons/icon-pencil-blue.svg')"
          />
        </div>
      </div>
      <div
        class="Fuell-TableInput--container"
        v-show="editableFlag"
      >
        <currency-input
          ref="currencyInput"
          v-model="assignedValue"
          @blur="submitChange"
          @keydown="handleCurrencyInputKeyDown"
          class="Fuell-TableInput"
          :allow-negative="false"
        ></currency-input>
        <div
          class="Fuell-TableInput--icon-container clickable"
          @click="submitChange"
          role="button"
        >
          <img
            alt="icon-check"
            :src="require('@/assets/img/icons/icon-check-blue.svg')"
          />
        </div>
      </div>
    </div>
    <router-link
      :to="`/budgets/detail/${budget.budget.id}/`"
      custom
      v-slot="{ navigate }"
    >
      <div
        class="Fuell-Table--item clickable"
        @click="navigate"
      >
        {{
        spent
          | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          })
      }}
      </div>

    </router-link>
    <router-link
      :to="`/budgets/detail/${budget.budget.id}/`"
      custom
      v-slot="{ navigate }"
    >
      <div
        class="Fuell-Table--item clickable"
        @click="navigate"
      >
        {{
        available
          | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          })
      }}
      </div>
    </router-link>
    <router-link
      :to="`/budgets/detail/${budget.budget.id}/`"
      custom
      v-slot="{ navigate }"
    >
      <div
        class="Fuell-Table--item clickable"
        @click="navigate"
      >
        <budget-progress-bar
          :spent="spent"
          :assigned="assigned"
          :goal="assigned"
          :available="available"
        ></budget-progress-bar>
      </div>
    </router-link>
    <router-link
      :to="`/budgets/detail/${budget.budget.id}/`"
      custom
      v-slot="{ navigate }"
    >
      <div
        class="Fuell-Table--item clickable"
        @click="navigate"
      >
        <span>
          {{userIdentifier}}
        </span>
      </div>
    </router-link>
    <router-link
      :to="`/budgets/detail/${budget.budget.id}/`"
      custom
      v-slot="{ navigate }"
    >
      <div
        class="Fuell-Table--item clickable"
        @click="navigate"
      >
        <span>
          {{userExpenseCenter}}
        </span>
      </div>
    </router-link>
  </div>
</template>

<script>
import UserNameBadge from '@/components/Commons/UserNameBadge'
import BudgetProgressBar from '@/modules/budgets/_components/_shared/BudgetProgressBar'
import { CurrencyInput } from 'vue-currency-input'

export default {
  name: 'UserBudgetsTableRow',
  components: {
    UserNameBadge,
    BudgetProgressBar,
    CurrencyInput
  },
  props: {
    budget: {
      type: Object
    }
  },
  data () {
    return {
      editableFlag: false,
      assignedValue: 0
    }
  },
  methods: {
    toggleEditFlag () {
      this.editableFlag = !this.editableFlag
      if (!this.editableFlag) {
        this.assignedValue = this.assigned
      } else {
        this.assignedValue = this.assigned
        setTimeout(() => {
          this.$refs.currencyInput.$el.focus()
          this.$refs.currencyInput.$el.select()
        }, 50)
      }
    },
    resetAssignedValue () {
      if (this.assignedValue == null) {
        this.assignedValue = this.assigned
      }
    },
    disableEditFlag () {
      setTimeout(() => {
        if (!this.isCallingUserBudgets) {
          this.editableFlag = false
          this.assignedValue = this.assigned
        }
      }, 200)
    },
    handleCurrencyInputKeyDown (ev) {
      if (ev.keyCode === 13) {
        this.submitChange()
      }
    },
    async submitChange () {
      if (this.assignedValue == null) {
        this.assignedValue = this.assigned
        this.toggleEditFlag()
        return
      }
      if (Number.parseFloat(this.assignedValue) > this.currentBudgetGoal) {
        this.$store.dispatch(
          'SnackBars/addError',
          this.$t('budgets_update_user_assign_greater_than_goal_error'),
          { root: true }
        )
        return
      }

      if (this.assignedValue === this.assigned) {
        this.toggleEditFlag()
        return
      }
      if (this.assignedValue < this.availableToAssign) {
        this.$store.dispatch('SnackBars/addError', this.$t('budgets_update_user_assign_lower_than_spent_error'), { root: true })
        this.toggleEditFlag()
        return
      }

      let updatedMember = Object.assign({}, this.budget)
      updatedMember.assigned = Number.parseFloat(this.assignedValue)
      await this.$store.dispatch('UsersStore/updateUserBudget', updatedMember)
      this.disableEditFlag()
    }
  },
  computed: {
    userIdentifier () {
      return this.budget.user.identifier
    },
    userExpenseCenter () {
      return this.budget.user.expenseCenter
    },
    userName () {
      return this.budget && this.budget.user
        ? `${this.budget.user.firstName} ${this.budget.user.lastName}`
        : ''
    },
    budgetName () {
      return this.budget && this.budget.budget && this.budget.budget.name
        ? this.budget.budget.name
        : ''
    },
    isOwner () {
      return this.budget && this.budget.isOwner
    },
    assigned () {
      return this.budget ? this.budget.assigned : ''
    },
    spent () {
      return this.budget ? this.budget.spent.toFixed(2) : ''
    },
    availableToAssign () {
      return this.member ? Number.parseFloat(this.member.spent.toFixed(2) - this.member.reimbursementSpent.toFixed(2)).toFixed(2) : null
    },
    available () {
      return this.budget && this.budget.available >= 0 ? this.budget.available.toFixed(2) : ''
    },
    spentPercent () {
      return (this.spent * 100) / this.available
    },
    availablePercent () {
      return 100 - this.spentPercent
    },
    userProfilePictureId () {
      return this.budget && this.budget.user && this.budget.user.profilePicture
        ? this.budget.user.profilePicture.id
        : 0
    },
    isCallingUserBudgets () {
      return this.$store.getters['UsersStore/isCallingUserBudgets']
    }
  },
  created () {
    this.asignedAmount = this.assigned
  }
}
</script>

<style scoped>
.user-name-field {
  display: flex;
  flex-direction: column;
  line-height: 20px;
}
.Fuell-Table--item >>> .progress--assigned {
  background-color: rgba(0, 137, 242, 0.4) !important;
}
</style>
